import { render, staticRenderFns } from "./FormSubmit.vue?vue&type=template&id=b8b726bc&scoped=true"
import script from "./FormSubmit.vue?vue&type=script&lang=ts"
export * from "./FormSubmit.vue?vue&type=script&lang=ts"
import style0 from "./FormSubmit.vue?vue&type=style&index=0&id=b8b726bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8b726bc",
  null
  
)

export default component.exports